import * as moment_ from 'moment';

const moment = moment_;

export class Utils {
  static generateId(length: number, timestamp: boolean = false) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    if (timestamp) {
      result += '-' + Date.now().toString(36);
    }
    return result;
  }

  static combineURLs(urls: string[]): string {
    return urls.join('/').replace(new RegExp('([^:]\\/)\\/+', 'g'), '$1');
  }

  static getTodayAsString() {
    const m = moment(new Date());
    return m.format('YYYY-MM-DD');
  }

  static getDateAsString(date) {
    const m = moment(date);
    return m.format('YYYY-MM-DD');
  }

  static toFullDateTime(d: string) {
    const m = moment(d);
    return `${m.format('dddd DD MMMM YYYY')} à ${m.format('HH')}h${m.format('mm')}`;
  }

  static toShortDateTime(d: string) {
    const m = moment(d);
    return `${m.format('DD-MM-YYYY')} à ${m.format('HH')}h${m.format('mm')}`;
  }

  static toMediumDate(d: string, format?: string) {
    return moment(d, format).format('dddd DD MMMM');
  }

  static toTime(d: string) {
    const m = moment(d);
    return `${m.format('HH')}h${m.format('mm')}`;
  }

  static semanticVersionToNumber(version: string): number {
    const p = version.split('.');
    return (+p[0] || 0) * 1000000 + (+p[1] || 0) * 10000 + (+p[2] || 0) * 100;
  }

  static isNumber(value: string | number): boolean {
    return (new RegExp('^[0-9]+$')).test(value.toString());
  }

  static isFloat(value: string | number): boolean {
    return (new RegExp('^([0-9]*[.])?[0-9]+$')).test(value.toString());
  }

  static isValidPercent(value: string | number): boolean {
    return (new RegExp('^([0-9]*[.])?[0-9]+%$')).test(value.toString());
  }

  static camelize(value: string): string {
    value = value.replace(/[-_\s.]+(.)?/g, (_, c) => c ? c.toUpperCase() : '');
    return value.substr(0, 1).toLowerCase() + value.substr(1);
  }

  static capitalizeFirstLetter(str: string): string {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  static merge(target, source) {
    for (const key of Object.keys(source)) {
      if (source[key] instanceof Object) {
        Object.assign(source[key], Utils.merge(target[key], source[key]))
      }
    }
    Object.assign(target || {}, source)
    return target;
  }
}
